import initialState from './initialState';
import Immutable from 'seamless-immutable';
import {types} from '../actions/zonesActions';

export default function zonesReducer(state = Immutable(initialState.zones), action) {
  switch (action.type) {
    case types.IMPORT_ZONES_FROM_OTHER_TENANT: {
      return Immutable.merge(state, {
        importing: true,
      });
    }
    case types.IMPORT_ZONES_FROM_OTHER_TENANT_SUCCESS: {
      return Immutable.merge(state, {
        importing: false,
      });
    }
    case types.IMPORT_ZONES_FROM_OTHER_TENANT_FAILURE: {
      return Immutable.merge(state, {
        importing: false
      });
    }
    default:
      return state;
  }
}
